import React from "react";

interface IButtonIcon {
  text: string;
  icon: React.ReactNode;
  onClick: () => void;
}
export const ButtonIcon = ({ text, icon, onClick }: IButtonIcon) => {
  return (
    <div className="button-icon" onClick={onClick}>
      {icon}
      <span>{text}</span>
    </div>
  );
};
